import { useCallback } from 'react';

import type { AdministrationUser } from '@/modules/api/codegen';
import { useUser } from '@/modules/auth/hooks';

export const useIsAdministrationTableRecordCurrentUser = () => {
    const loggedInUser = useUser();

    const isTableRecordCurrentUser = useCallback(
        (record: AdministrationUser) => {
            return record.id === loggedInUser?.id;
        },
        [loggedInUser?.id],
    );

    return isTableRecordCurrentUser;
};
